import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CHART_COLORS } from '../../../utils/chartColors';
import EmptyState from '../../../components/ui/EmptyState';

export default function RejectionsView({ data }) {
  if (data.by_step.length === 0) return <EmptyState title="No rejections in this range." />;

  return (
    <div>
      <p className="mb-4 text-sm text-gray-600">
        <strong>{data.total_rejections}</strong> total rejections
      </p>
      <ResponsiveContainer width="100%" height={Math.max(220, data.by_step.length * 32)}>
        <BarChart data={data.by_step} layout="vertical" margin={{ left: 24 }}>
          <CartesianGrid strokeDasharray="0" horizontal={false} stroke={CHART_COLORS.grid} />
          <XAxis type="number" allowDecimals={false} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis type="category" dataKey="title" width={200} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={{ borderRadius: 8, borderColor: CHART_COLORS.grid, fontSize: 13 }} />
          <Bar dataKey="count" fill={CHART_COLORS.primary} radius={[0, 4, 4, 0]} maxBarSize={18} />
        </BarChart>
      </ResponsiveContainer>

      <div className="mt-4 space-y-3">
        {data.by_step.map((s) => (
          <div key={s.code} className="rounded-md border border-gray-100 p-3">
            <p className="text-sm font-medium text-gray-900">
              {s.title} <span className="text-gray-400">({s.count})</span>
            </p>
            {s.reasons.length > 0 && (
              <ul className="mt-1 list-inside list-disc text-xs text-gray-500">
                {s.reasons.map((r) => (
                  <li key={r}>{r}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
